import classNames from "classnames";
import { memo } from "react";
import * as dividerCss from "./divider.module.css";
import { Flex } from "./flex";
import { styleClasses, StyleProps } from "./styles";

export const Divider = memo(function Divider({
  classes,
  direction = "horizontal",
}: {
  classes?: string;
  direction?: "horizontal" | "vertical";
}) {
  if (direction === "vertical") {
    return (
      <Flex
        alignSelf="stretch"
        as="hr"
        borderColor="primary"
        borderLeftWidth="1px"
        borderStyle="solid"
        className={classes}
        data-web="Divider"
        m="none"
        w="none"
      />
    );
  }
  return (
    <hr
      className={classNames(dividerCss.divider, classes)}
      data-web="Divider"
    />
  );
});

interface DividerWithTextProps extends StyleProps {
  text: string;
}

export const DividerText = memo(function DividerText(
  props: DividerWithTextProps,
) {
  return (
    <div
      className={classNames(styleClasses({ ...props }), dividerCss.dividerText)}
      data-web="DividerText"
    >
      {props.text}
    </div>
  );
});
